import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Input, InputGroup } from 'reactstrap';

import { Table, TableBody, TableRow, TableData, TableHead, TableHeading } from 'components/CMSRankList/styles';
import {
  Label,
  SponsorTabContainer,
  SponsorTabInnerContainer,
  SponsorDateContainer,
  CompanyNameContainer,
  OldSponsorContainer,
  OldSponsorHeading,
  Select,
  Option,
} from '../styles';

export default React.memo(({ updateContestDetails }) => {
  let { contest } = useSelector((state) => state.CMSEditContestReducer);

  const [sponsorStartDate, setSponsorStartDate] = useState(
    contest.sponsorStartDate ? moment(contest?.sponsorStartDate).format('YYYY-MM-DD') : ''
  );
  const [sponsorEndDate, setSponsorEndDate] = useState(
    contest.sponsorEndDate ? moment(contest.sponsorEndDate).format('YYYY-MM-DD') : ''
  );
  const [sponsorCompany, setSponsorCompany] = useState(contest?.sponsorCompany ?? '');

  return (
    <SponsorTabContainer>
      <SponsorTabInnerContainer>
        <SponsorDateContainer padding="0 10px 0 0">
          <Label>Start date:</Label>
          <InputGroup>
            <Input
              type="date"
              value={sponsorStartDate}
              onChange={(e) => {
                setSponsorStartDate(e.target.value);
                updateContestDetails({ sponsorStartDate: e.target.value });
              }}
            />
          </InputGroup>
        </SponsorDateContainer>
        <SponsorDateContainer padding="0 10px 0 0">
          <Label>End date:</Label>
          <InputGroup>
            <Input
              type="date"
              value={sponsorEndDate}
              onChange={(e) => {
                setSponsorEndDate(e.target.value);
                updateContestDetails({ sponsorEndDate: e.target.value });
              }}
            />
          </InputGroup>
        </SponsorDateContainer>
        <CompanyNameContainer padding="0 10px 0 0">
          <Label>Select company:</Label>
          <Select
            value={sponsorCompany}
            onChange={(e) => {
              setSponsorCompany(e.target.value);
              updateContestDetails({ sponsorCompany: e.target.value });
            }}
          >
            {!sponsorCompany && <Option value="">Select company</Option>}
            {contest.companiesList.map((company, index) => {
              return (
                <Option value={company._id} key={index}>
                  {company.name}
                </Option>
              );
            })}
          </Select>
        </CompanyNameContainer>
      </SponsorTabInnerContainer>
      {!!contest.oldSponsors?.length && (
        <OldSponsorContainer>
          <OldSponsorHeading>Previous Sponsors</OldSponsorHeading>
          <Table>
            <TableHead>
              <TableRow isHeading>
                <TableHeading>Company</TableHeading>
                <TableHeading>Sponsor Start Date</TableHeading>
                <TableHeading>Sponsor End Date</TableHeading>
              </TableRow>
            </TableHead>
            <TableBody>
              {contest.oldSponsors.map((sponsor, index) => {
                return (
                  <TableRow key={index}>
                    <TableData>{sponsor.companyName}</TableData>
                    <TableData>{moment(sponsor.startDate).format('DD-MM-YYYY')}</TableData>
                    <TableData>{moment(sponsor.endDate).format('DD-MM-YYYY')}</TableData>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </OldSponsorContainer>
      )}
    </SponsorTabContainer>
  );
});
